import { Stack } from "@mui/material"
import { ReactElement, useContext } from "react"

import CreateDeviceProgressStepper from "./components/progressStepper/createDeviceProgressStepper"
import TTRAttachments from "./formPages/attachments/attachments"
import CoreDeviceDetails from "./formPages/coreDeviceDetails/coreDeviceDetails"
import Manufacturer from "./formPages/manufacturer/manufacturer"
import ReviewAndSubmit from "./formPages/reviewAndSubmit/reviewAndSubmit"
import TypeTestDetails from "./formPages/typeTestDetails/typeTestDetails"
import { CreateDeviceContext } from "./providers/baseProviders/createDeviceProvider"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"
import MultiPageForm from "../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../surfaces/appCard"

const CreateDeviceForm = (): ReactElement => {
    const { canEditManufacturer } = useContext(CreateDeviceContext)

    return (
        <Stack spacing={GRID_SPACING}>
            <AppCard>
                <AppCardContent>
                    <CreateDeviceProgressStepper />
                </AppCardContent>
            </AppCard>

            <MultiPageForm context={CreateDeviceContext}>
                {canEditManufacturer && (
                    <Manufacturer context={CreateDeviceContext} />
                )}
                <CoreDeviceDetails context={CreateDeviceContext} />
                <TypeTestDetails context={CreateDeviceContext} />
                <TTRAttachments context={CreateDeviceContext} />
                <ReviewAndSubmit context={CreateDeviceContext} />
            </MultiPageForm>
        </Stack>
    )
}

export default CreateDeviceForm
